/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiErrorResponseFromJSON, StreemApiErrorResponseToJSON, } from './';
export function StreemApiBatchCreateCompanyResponseFailureFromJSON(json) {
    return StreemApiBatchCreateCompanyResponseFailureFromJSONTyped(json, false);
}
export function StreemApiBatchCreateCompanyResponseFailureFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'error': !exists(json, 'error') ? undefined : StreemApiErrorResponseFromJSON(json['error']),
        'companyCode': !exists(json, 'company_code') ? undefined : json['company_code'],
        'ownerEmail': !exists(json, 'owner_email') ? undefined : json['owner_email'],
    };
}
export function StreemApiBatchCreateCompanyResponseFailureToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'error': StreemApiErrorResponseToJSON(value.error),
        'company_code': value.companyCode,
        'owner_email': value.ownerEmail,
    };
}
//# sourceMappingURL=StreemApiBatchCreateCompanyResponseFailure.js.map